module.exports = __webpack_public_path__ + "img/currency3.b5dbf0a2.png";